export const TASK_STATUS_OPTIONS = [
  { value: "A faire", label: "À faire" },
  { value: "En cours", label: "En cours" },
  { value: "Urgent", label: "Urgent" },
  { value: "Terminee", label: "Terminée" },
];

export const TASK_STATUS_KANBAN_COLUMNS = [
  {
    id: "status-a-faire",
    title: "À faire",
    status: "A faire",
    statut: "A faire",
    color: "#f59e0b",
    mode: "status",
  },
  {
    id: "status-en-cours",
    title: "En cours",
    status: "En cours",
    statut: "En cours",
    color: "#38bdf8",
    mode: "status",
  },
  {
    id: "status-urgent",
    title: "Urgent",
    status: "Urgent",
    statut: "Urgent",
    color: "#ef4444",
    mode: "status",
  },
  {
    id: "status-terminee",
    title: "Terminée",
    status: "Terminee",
    statut: "Terminee",
    color: "#22c55e",
    mode: "status",
  },
];

export const TASK_GROUP_BY_OPTIONS = [
  { value: "product", label: "Colonnes par application" },
  { value: "status", label: "Colonnes par statut" },
];

export const TASK_PRIORITY_OPTIONS = [
  { value: "LOW", label: "Basse" },
  { value: "NORMAL", label: "Normale" },
  { value: "HIGH", label: "Haute" },
  { value: "URGENT", label: "Urgente" },
];

export const TASK_SORT_OPTIONS = [
  { value: "position", label: "Ordre Kanban" },
  { value: "due_asc", label: "Échéance la plus proche" },
  { value: "due_desc", label: "Échéance la plus lointaine" },
  { value: "priority", label: "Priorité forte d’abord" },
];

export const TASK_LABEL_COLORS = [
  "#facc15",
  "#22c55e",
  "#3b82f6",
  "#a855f7",
  "#f97316",
  "#ef4444",
  "#14b8a6",
  "#64748b",
];

export const DEFAULT_TASK_FORM = {
  categorie: "Général",
  titre: "",
  contenu: "",
  asso_id: "",
  product_app_id: "",
  statut: "A faire",
  priority: "NORMAL",
  due_date: "",
  cover_url: "",
  label_color: "#facc15",
  labels_json: [],
  checklist_json: [],
  members_json: [],
  attachments_json: [],
  comments_json: [],
};

export const EMPTY_TASK_STATS = {
  total: 0,
  urgent: 0,
  done: 0,
  late: 0,
};